import React from 'react';
import { IValueChipRow } from './interface';
import { ValueRow } from '../ValueRow';
import { Chip, Stack } from '@mui/material';

export const ValueChipRow: React.FC<IValueChipRow> = ({
  label,
  value,
  width = '50px',
}): JSX.Element => {
  return (
    <ValueRow label={label} width={width}>
      {value?.length ? (
        <Stack direction="row" gap="5px">
          {value.map((item, index) => (
            <Chip size="small" key={index} label={item} />
          ))}
        </Stack>
      ) : (
        '-'
      )}
    </ValueRow>
  );
};
